var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatNofication({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91602 16.9168H18.0827M9.91602 11.0835H13.9993",
    stroke: "#0A0F0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.533 24.3721C21.4132 24.0478 25.3005 20.1052 25.6204 15.1559C25.6829 14.1873 25.6829 13.1842 25.6204 12.2157C25.3005 7.26628 21.4132 3.32382 16.533 2.99942C14.8681 2.88875 13.1298 2.88898 11.4683 2.99942C6.5881 3.32382 2.70079 7.26628 2.38093 12.2157C2.31834 13.1842 2.31834 14.1873 2.38093 15.1559C2.49743 16.9585 3.29465 18.6275 4.23321 20.0369C4.77816 21.0235 4.41851 22.2549 3.85089 23.3306C3.44163 24.1062 3.23699 24.494 3.40129 24.7741C3.56561 25.0542 3.93262 25.0632 4.66665 25.0811C6.11826 25.1164 7.09711 24.7048 7.87411 24.1319C8.31478 23.807 8.53513 23.6444 8.68699 23.6258C8.83885 23.6071 9.13771 23.7302 9.73533 23.9764C10.2724 24.1976 10.8961 24.3341 11.4683 24.3721C13.1298 24.4826 14.8681 24.4828 16.533 24.3721Z",
    stroke: "#0A0F0D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNofication);
export default __webpack_public_path__ + "static/media/chat-nofication.edd63a20f70baaa392c561f35cf85237.svg";
export { ForwardRef as ReactComponent };